import { useTheme } from '@emotion/react';

export function AttentionBanner({ text }: { text: string }) {
  const theme = useTheme();
  return (
    <div
      css={{
        display: 'flex',
        backgroundColor: '#f44336',
        padding: '3px 9px',
        fontFamily: 'Golos',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '13px',
        lineHeight: '140%',
        color: theme.colors.textWhite,
      }}
    >
      <span>
        <b>{text}</b>
      </span>
    </div>
  );
}
